<template>
  <div class="delivery-block">
    <header>
      <h3 class="float-left">Verkäufer</h3>
      <b-button variant="primary" @click="() => selectorVisible = true">
        Wählen
      </b-button>
    </header>

    <b-form-group label="LFBIS-Nr.:" label-cols="4">
      <b-input type="text" v-model="data.sellerFactory.lfbis" class="text-right float-right" maxlength="7" :style="{ width: '130px' }"
               :disabled="disabled || saving"/>
    </b-form-group>
    <b-form-group label="Ring-Nr.:" label-cols="4">
      <b-input type="text" v-model="data.sellerFactory.ringNr" class="text-right float-right" maxlength="4" :style="{ width: '90px' }"
               :disabled="disabled || saving"/>
    </b-form-group>
    <b-form-group label="Name und Anschrift.:">
      <b-textarea v-model="data.sellerFactory.contact" rows="4"
                  :disabled="disabled || saving"/>
    </b-form-group>
    <b-form-group label="Tel.Nr.:" label-cols="12" label-cols-sm="2">
      <b-input v-model="data.sellerFactory.phone"
               :disabled="disabled || saving"/>
    </b-form-group>
    <b-form-group label="Betreuungstierarzt (Name, Anschrift):">
      <b-textarea v-model="data.sellerFactory.veterinary" rows="3"
                  :disabled="disabled || saving"/>
    </b-form-group>
    <b-form-group label="TGD-Teilnahme.:" label-cols="12" label-cols-md="6">
      <b-checkbox v-model="data.sellerFactory.veterinaryTgd"
                  unchecked-value="Nein"
                  value="Ja"
               :disabled="disabled || saving"/>
    </b-form-group>

    <h6>AKTIONSPROGRAMM SCHWANZKUPIEREN</h6>
    <b-form-group v-if="context === 'pigSty'" label="Die Unerlässlichkeit des Schwanzkupierens wurde auf meinem Betrieb im Sinne der Vorgaben der 1. THVO festgestellt:" label-cols="12" label-cols-md="6">
      <b-form-radio-group v-model="data.sellerFactory.cropTail" name="crop-tail">
        <b-form-radio value="Ja">Ja</b-form-radio>
        <b-form-radio value="Nein">Nein</b-form-radio>
      </b-form-radio-group>
    </b-form-group>

    <h6>TEILNAHME TGD PROGRAMM "EXPORT"</h6>
    <b-form-group v-if="context==='pigSty'" label="TGD-Programm 1" label-cols="12" label-cols-md="6">
      <b-checkbox v-model="data.sellerFactory.tgdExportProgram1"
                  unchecked-value="Nein"
                  value="Ja"
                  :disabled="disabled || saving"></b-checkbox>
    </b-form-group>
    <b-form-group v-if="context==='pigSty'" label="TGD-Programm 2" label-cols="12" label-cols-md="6">
      <b-checkbox v-model="data.sellerFactory.tgdExportProgram2"
                  unchecked-value="Nein"
                  value="Ja"
                  :disabled="disabled || saving"></b-checkbox>
    </b-form-group>




    <b-form-group v-if="context === 'piglet'" label="Alle mönnlichen Ferkel wurden unter Narkose kastriert.:" label-cols="12" label-cols-md="8">
      <b-form-radio-group v-model="data.sellerFactory.allMaleCastratedUnderAnesthetic" name="allMaleCastratedUnderAnesthetic">
        <b-form-radio value="Ja">Ja</b-form-radio>
        <b-form-radio value="Nein">Nein</b-form-radio>
      </b-form-radio-group>
    </b-form-group>
    <modal-select-factory title="Foobar"
                          @cancel="() => selectorVisible = false"
                          @select="onFactorySelect"
                          v-if="selectorVisible"/>
  </div>
</template>

<script>
import {computed, ref, watch} from '@vue/composition-api'
import ModalSelectFactory from "@/app/components/delivery/ModalSelectFactory.vue";

export default {
  components: {ModalSelectFactory},
  props: {
    value: { type: Object, required: true },
    disabled: { type: Boolean, required: true },
    saving: { type: Boolean, required: true },
    context: {type: String, required: true}
  },

  setup(props, { emit }) {
    const data = ref(props.value)
    const selectorVisible = ref(false)
    const store = window.useStore();
    const veterinarians = computed(() => store.state.pwa.deliveries.piglet.config.veterinarians)

    watch(data, () => {
      emit('change', data)
    }, { deep: true })

    const onFactorySelect = async (factory) => {
      const mobileContacts = factory.contacts.filter(c => c.type === 'mobile')
      const phone = mobileContacts && mobileContacts.length ? mobileContacts[0].value : null
      data.value.sellerFactoryId = factory.id
      data.value.sellerFactory = {
        lfbis: ('' + factory.businessIdentifier.lfbis).trim(),
        ringNr: factory.factoryModel.ringNr,
        contact: [
          factory.factoryModel.name,
          factory.factoryModel.street,
          [factory.factoryModel.placeModel.zip, factory.factoryModel.placeModel.name].join(' '),
          factory.factoryModel.countryModel.name,
        ].join("\n"),
        phone: phone,
      }
      if (veterinarians && veterinarians.value.data[factory.veterinarianId])
      {
        const vetPhone = [];
        if(veterinarians.value.data[factory.veterinarianId].contacts) {
          const searchTypes = ["mobile", "phone"]
          for (let type of searchTypes) {
            const contact = veterinarians.value.data[factory.veterinarianId].contacts.find(d => d.type === type);
            if(contact)
              vetPhone.push(contact.value);
          }
        }
        const veterinary = veterinarians.value.data[factory.veterinarianId];
        data.value.sellerFactory.veterinary = [
          veterinary.name,
          veterinary.street,
          veterinary.place,
          vetPhone.join('\n')
        ].join('\n');
      }
    }

    return {
      data,
      selectorVisible,
      onFactorySelect,
    }
  }
}
</script>
